import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/react';

import { routes } from './routes';
import { Toaster } from './components/ui/sonner';
import {
  AccountAuthProvider,
  AccountSyncBootstrap,
  ClerkAccountAuthProvider,
  CLERK_PUBLISHABLE_KEY,
} from './features/account';
import { SourceAuthRefreshPersister } from './features/auth/SourceAuthRefreshPersister';

const router = createBrowserRouter(routes);

export function App() {
  const app = (
    <>
      {CLERK_PUBLISHABLE_KEY && <AccountSyncBootstrap />}
      <SourceAuthRefreshPersister />
      <RouterProvider router={router} />
      <Toaster />
    </>
  );

  if (!CLERK_PUBLISHABLE_KEY) {
    return <AccountAuthProvider>{app}</AccountAuthProvider>;
  }

  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <ClerkAccountAuthProvider>{app}</ClerkAccountAuthProvider>
    </ClerkProvider>
  );
}
